const {
	trackGtm,
	fillWithDomElements,
	fillWithDomElementsAll,
} = require('../../../../js/functions');

const SELECTOR_SMALL_IMAGE = '.small-image-above-title';
const SELECTOR_DOWNLOAD_LINK = '.basic-video--download';

const CLASS_MODAL_OPENER = 'modal-opener';
const CLASS_CONTENT = 'carousel-highlight--content';
const CLASS_MODAL_CONTROLLERS = 'modal-controller';

const selector = {
	content: CLASS_CONTENT,
};
const selectorAll = {
	openers: CLASS_MODAL_OPENER,
	modalControllers: CLASS_MODAL_CONTROLLERS,
};

module.exports = {
	init() {
		fillWithDomElements(this, selector);
		fillWithDomElementsAll(this, selectorAll);

		this.openers.forEach(element => {
			element.addEventListener('click', () => {
				const parent = element.closest(SELECTOR_SMALL_IMAGE);
				const index = [...this.content.children].indexOf(parent);
				const downloadLink = this.modalControllers[index].querySelector(
					SELECTOR_DOWNLOAD_LINK,
				);
				if (downloadLink) {
					const { href } = downloadLink;
					trackGtm({
						eventCategory: 'cta',
						eventAction: 'video',
						eventLabel: href,
					});
				}
			});
		});
	},
};
